<template>
  <div id="projectManage">
    <el-row>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>数据管理</el-breadcrumb-item>
        <el-breadcrumb-item>数据查询</el-breadcrumb-item>
      </el-breadcrumb>
      <el-divider></el-divider>
    </el-row>
    <el-row>
      <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle">
        <el-table-column type="index" width="50" />
        <el-table-column prop="time" label="时间">
        </el-table-column>
        <el-table-column prop="device_id" label="设备Id">
        </el-table-column>
        <el-table-column prop="channel_id" label="通道ID">
        </el-table-column>
        <el-table-column prop="value" label="电阻值">
        </el-table-column>
        <el-table-column prop="project_name" label="路段">
        </el-table-column>
        <el-table-column prop="segment_name" label="切面">
        </el-table-column>
        <el-table-column prop="layer_index" label="层">
        </el-table-column>
        <el-table-column prop="sequence_index" label="序号">
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-sizes="[5, 10, 20]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>

import api from '@/api/api'
import * as moment from 'moment';

export default {
  name: 'projectManage',
  components: {
  },
  data() {
    return {
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      headerCellStyle: {
        background: 'rgb(245,245,245)'
      },
      tableData: []
    }
  }, mounted() {
    const that = this;
    that.refresh();
    that.moment = moment;
  },
  methods: {
    refresh() {
      const that = this;
      api.post('/sensorData', { pageSize: that.pageSize, pageIndex: that.pageIndex }).then(response => {
        that.totalCount = response.data.totalCount;
        that.tableData = response.data.data.map(data => {
          data.time= that.moment(data.time).format('YYYY-MM-DD HH:mm:ss')
          return data;
        });
      })
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.refresh();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.refresh();
    }
  }
}
</script>

<style lang="less" scoped>
#projectManage {
  padding: 20px;
}

.buttons {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
}
</style>
